import axiosInstance from 'api/base';
import { IBaseResponse } from 'utils/types';

import { normalizeSharedLink, normalizeShortLink } from './normalizers';
import { ISharedLink } from './types';

const sharedLinkApi = {
  async createShortLink(payload: ISharedLink): Promise<IBaseResponse<string>> {
    const { data } = await axiosInstance.post('goto', payload);
    return normalizeShortLink(data);
  },

  async getSharedLink(shortLink: string): Promise<ISharedLink> {
    const { data } = await axiosInstance.get(`goto/${shortLink}`);
    return normalizeSharedLink(data);
  },
};

export default sharedLinkApi;
